import { createContext, useReducer } from 'react';

const initialState = {
  countries: [],
  flights: [],
  arrivalStation: {
    name: '',
    codes: '',
  },
  departureStation: {
    name: '',
    codes: '',
  },
  date: {
    string: '',
    value: '',
  },
  flightNumber: '',
  searchedDeparture: {},
  searchedArrival: {},
  searchedDate: '',
  parsedDestinations: [],
  airports: [],
  flightsFilter: 'flightsstatus.results.status.any',
  isFirstFetch: true,
  flightPosition: null,
  get_countries_status: '',
  get_flights_list_status: '',
  get_flight_position_status: '',
  modal: {
    id: '',
    open: false,
  },
};

const FlightStatusContext = createContext({
  state: initialState,
  dispatch: () => {},
  displayName: 'FlightStatusContext',
});

function reducer(state, { type, payload }) {
  switch (type) {
    case 'HANDLE_MODAL': {
      return {
        ...state,
        modal: {
          ...state.modal,
          ...payload,
        },
      };
    }
    case 'HANDLE_CHANGE_STATE': {
      return {
        ...state,
        ...payload,
      };
    }
    case 'GET_COUNTRIES_SUCCESS': {
      return {
        ...state,
        countries: payload,
        get_countries_status: 'success',
      };
    }
    case 'GET_COUNTRIES_LOADING': {
      return {
        ...state,
        get_countries_status: 'loading',
      };
    }
    case 'GET_COUNTRIES_ERROR': {
      return {
        ...state,
        get_countries_status: 'error',
      };
    }
    case 'GET_FLIGHTS_LIST_SUCCESS': {
      return {
        ...state,
        flights: payload,
        get_flights_list_status: state.isFirstFetch
          ? 'success-first'
          : 'success',
        flightsFilter: 'flightsstatus.results.status.any',
        isFirstFetch: false,
      };
    }
    case 'GET_FLIGHTS_LIST_LOADING': {
      return {
        ...state,
        get_flights_list_status: 'loading',
      };
    }
    case 'GET_FLIGHTS_LIST_ERROR': {
      return {
        ...state,
        get_flights_list_status: 'error',
        flights: payload,
      };
    }
    case 'GET_FLIGHT_POSITION_SUCCESS': {
      return {
        ...state,
        flightPosition: payload,
        get_flight_position_status: 'success',
      };
    }
    case 'GET_FLIGHT_POSITION_LOADING': {
      return {
        ...state,
        get_flight_position_status: 'loading',
      };
    }
    case 'GET_FLIGHT_POSITION_ERROR': {
      return {
        ...state,
        flightPosition: null,
        get_flight_position_status: 'error',
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${type}`);
    }
  }
}

function FlightStatusProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <FlightStatusContext.Provider value={{ state, dispatch }}>
      {children}
    </FlightStatusContext.Provider>
  );
}

export { FlightStatusProvider, FlightStatusContext };
